<template>
  <div class="gheom-card" 
    :class="getMyTypeClass(this.myproduct.type)">
    <div class="gheom__card__wrapper">
      <div class="header">
        <p class="name">{{myproduct.name}}</p>
      </div>
      <div class="content">
        <div class="content--actions">
          <p>Last tested on <span>{{myproduct.gheoms[lastTestedGheom].crop.name}}</span> in United States</p>


          <gheom-tooltip>

            <div class="tooltip__heading">
                <div class="heading__crops">
                  <p class="title">Crops</p>
                  <ul>
                    <li v-for="thecrop in myproduct.applied_crops">
                      <img :src="'/crop/pic/tblack/'+thecrop.logo_name" />
                      <span>{{gheomsThisCrop(thecrop.pivot.crop_id)}}</span>
                      <p>{{thecrop.name}}</p>
                    </li>
                  </ul>
                </div>
                <div class="heading__meta">
                  <div>
                    <p class="meta__title">State</p>
                    <p class="meta__content">Liquid?</p>
                  </div>
                  <div>
                    <p class="meta__title">Nature</p>
                    <p class="meta__content">Inorganic?</p>
                  </div>
                  <div>
                    <p class="meta__title">Tested</p>
                    <p class="meta__content">{{testedRange}}</p>
                  </div>
                </div>
            </div>

            <ul class="tooltip__navigation">
              <li><a>Edit Product</a></li>
              <li><a>Add Gheom</a></li>
              <li><a>Extra actions</a></li>
            </ul>

            <!--<gheom-tooltip-func :func="myfunc"></gheom-tooltip-func>-->

          </gheom-tooltip>



        </div>
        <div class="content--stats">
          <div>
            <p class="title">Gheoms</p>
            <p class="figure">{{myproduct.gheoms.length}}</p>
          </div>
          <div>
            <p class="title">Crops</p>
            <p class="figure">{{myproduct.applied_crops.length}}</p>
          </div>
          <div>
            <p class="title">Countries</p>
            <p class="figure">1</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Shared from '../Shared'

export default {
  extends: Shared,
  name: "",
  props: [
    "myproduct"
  ],
  data:function(){ 
    return {
      show_tooltip: false
    }
  },
  computed: {
    shownStatus: function() {
      let theclass = "";
      (this.show_tooltip == true)? theclass = "tooltip--active" : theclass = "";
      return theclass;
    },

    testedRange: function () {
      let minCreated = "UND";
      let maxUpdated = "UND";

      if (this.myproduct.gheoms.length > 0) {
        minCreated = this.myproduct.gheoms[0].stagedates[0].control_date;
        maxUpdated = this.myproduct.gheoms[0].stagedates[0].control_date;

        this.myproduct.gheoms.forEach((singleGheom) => {
          singleGheom.stagedates.forEach((stage) => {
            (stage.control_date == stage.treated_date && stage.control_date < minCreated)? minCreated = stage.control_date : "";
            (stage.control_date == stage.treated_date && stage.control_date > maxUpdated)? maxUpdated = stage.control_date : "";
          })
        })
      } 
      return moment(minCreated).format("MMM [']YY") + " - " + moment(maxUpdated).format("MMM [']YY")
    },

    lastTestedGheom: function () {
      let gh_index = 0;
      if (this.myproduct.gheoms.length > 0) {
        let minTested = this.myproduct.gheoms[0].stagedates[0].control_date;
  
        this.myproduct.gheoms.forEach((singleGheom, index) => {
          singleGheom.stagedates.forEach((stage) => {
            (stage.control_date == stage.treated_date && stage.control_date > minTested)? gh_index = index : "";
          })
        })
      }

      return gh_index
    }
  },
  methods: {
    showTooltip() {
      this.show_tooltip = true;
      this.$emit("activatetooltip")
    },

    gheomsThisCrop: function(idCrop) {
      return this.myproduct.gheoms.filter(gheom => gheom.crop_id = idCrop).length
    },

    myfunc(){
      console.log('añsdjfñasjdfñkladj');
    }
  }
}
</script>
